import { render, staticRenderFns } from "./banci.vue?vue&type=template&id=7442f835&scoped=true&"
import script from "./banci.vue?vue&type=script&lang=js&"
export * from "./banci.vue?vue&type=script&lang=js&"
import style0 from "./banci.vue?vue&type=style&index=0&id=7442f835&lang=scss&scoped=true&"
import style1 from "./banci.vue?vue&type=style&index=1&id=7442f835&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7442f835",
  null
  
)

export default component.exports